import { ContributionStoreProps } from "@ctypes";
import { useContributionStore } from "@stores";

export const useContributionFlow = () => {
  const { contributionProps, setContributionProps: setContributionPropsFromStore } =
    useContributionStore();

  const setContributionProps = (newContributionProps: ContributionStoreProps) => {
    setContributionPropsFromStore({
      ...contributionProps,
      ...newContributionProps,
    });
  };

  const clearContributionProps = () => {
    setContributionPropsFromStore({});
  };

  const resetContributionProps = (newContributionProps: ContributionStoreProps) => {
    setContributionPropsFromStore(newContributionProps);
  };

  return {
    contributionProps,
    setContributionProps,
    clearContributionProps,
    resetContributionProps,
  };
};
